import { QuoteOrSignUpValue } from './formState';
import { sendTrace } from '../../../utils/tracking';

// fields must be flatterned coz we need to generate reports from mixpanel
export interface QuotePageTrace {
  fromPage: string;
  pageName: string;
  toPage: string;
  regionStart?: any;
  regionEnd?: any;
  quantityStart?: any;
  quantityEnd?: any;
  additivesStart?: any;
  additivesEnd?: any;
  aggStart?: any;
  aggEnd?: any;
  colourStart?: any;
  colourEnd?: any;
  mpaStart?: any;
  mpaEnd?: any;
  productTypeIdStart?: any;
  productTypeIdEnd?: any;
  slumpStart?: any;
  slumpEnd?: any;
  companyNameStart?: any;
  companyNameEnd?: any;
  emailStart?: any;
  emailEnd?: any;
  firstNameStart?: any;
  firstNameEnd?: any;
  isTradeCustomerStart?: any;
  isTradeCustomerEnd?: any;
  lastNameStart?: any;
  lastNameEnd?: any;
  mobileStart?: any;
  mobileEnd?: any;
  occupationStart?: any;
  occupationEnd?: any;
  occupationOtherStart?: any;
  occupationOtherEnd?: any;
  passcodeStart?: any;
  passcodeEnd?: any;
  quoteOrSignUpStart?: any;
  quoteOrSignUpEnd?: any;
}

let currentPage: QuotePageTrace = {
  fromPage: '',
  pageName: '',
  toPage: '',
};

let lastPage = '';

export function startQuoteTracePage(pageName: string, startObject: any): void {
  if (pageName === 'quoteOrSignup') {
    currentPage.pageName = 'quoteOrSignup';
    // eslint-disable-next-line no-nested-ternary
    currentPage.quoteOrSignUpStart = startObject.quoteOrSignUp ? (QuoteOrSignUpValue.QUOTE ? 'quote' : 'pricing') : '';
    currentPage.quantityStart = startObject?.quantity || 0;
  }
  if (pageName === 'region') {
    currentPage.pageName = 'region';
    currentPage.regionStart = startObject?.location?.locality || '';
    currentPage.quantityStart = startObject?.quantity || 0;
  }
  if (pageName === 'mix') {
    currentPage.pageName = 'mix';
    currentPage.additivesStart = startObject?.additives || '';
    currentPage.aggStart = startObject?.agg || '';
    currentPage.colourStart = startObject?.colour || '';
    currentPage.mpaStart = startObject?.mpa || '';
    currentPage.productTypeIdStart = startObject?.productTypeId || '';
    currentPage.slumpStart = startObject?.slump || '';
  }
  if (pageName === 'register') {
    currentPage.pageName = 'register';
    currentPage.companyNameStart = startObject?.companyName || '';
    currentPage.emailStart = startObject?.email || '';
    currentPage.firstNameStart = startObject?.firstName || '';
    currentPage.isTradeCustomerStart = startObject?.isTradeCustomer || '';
    currentPage.lastNameStart = startObject?.lastName || '';
    currentPage.mobileStart = startObject?.mobile || '';
    currentPage.occupationStart = startObject?.occupationOther || '';
    currentPage.occupationOtherStart = startObject?.occupationOther || '';
  }
  if (pageName === 'passcode') {
    currentPage.pageName = 'passcode';
    currentPage.passcodeStart = startObject?.passcode || '';
  }
}

let pageEndTempHolder: any = {};

export function clearQuoteTrace(page: string) {
  currentPage = {
    fromPage: '',
    pageName: '',
    toPage: '',
  };

  pageEndTempHolder = {};

  if (['region', 'mix', 'register', 'passcode'].indexOf(page) === -1) {
    lastPage = '';
  }
}

export function setCurrentPageLeaver(page: string, toPage: string): void {
  currentPage.fromPage = lastPage;
  currentPage.pageName = page;
  currentPage.toPage = toPage;
  lastPage = page;
  currentPage = { ...currentPage, ...pageEndTempHolder };
  sendTrace(currentPage);
  clearQuoteTrace(toPage);
}

export function endQuoteTracePage(page: string, startObject: any): void {
  // currentPage.toPage = currentPageLeaver.toPage;
  if (page === 'quoteOrSignup') {
    currentPage.pageName = 'quoteOrSignup';
    // eslint-disable-next-line no-nested-ternary
    currentPage.quoteOrSignUpEnd = startObject.quoteOrSignUp ? (QuoteOrSignUpValue.QUOTE ? 'quote' : 'pricing') : '';
    currentPage.quantityEnd = startObject?.quantity || 0;
  }
  if (page === 'region') {
    pageEndTempHolder.regionEnd = startObject?.location?.locality || '';
    pageEndTempHolder.quantityEnd = startObject?.quantity || 0;
  }
  if (page === 'mix') {
    pageEndTempHolder.additivesEnd = startObject?.additives || '';
    pageEndTempHolder.aggEnd = startObject?.agg || '';
    pageEndTempHolder.colourEnd = startObject?.colour || '';
    pageEndTempHolder.mpaEnd = startObject?.mpa || '';
    pageEndTempHolder.productTypeIdEnd = startObject?.productTypeId || '';
    pageEndTempHolder.slumpEnd = startObject?.slump || '';
  }
  if (page === 'register') {
    pageEndTempHolder.companyNameEnd = startObject?.companyName || '';
    pageEndTempHolder.emailEnd = startObject?.email || '';
    pageEndTempHolder.firstNameEnd = startObject?.firstName || '';
    pageEndTempHolder.isTradeCustomerEnd = startObject?.isTradeCustomer || '';
    pageEndTempHolder.lastNameEnd = startObject?.lastName || '';
    pageEndTempHolder.mobileEnd = startObject?.mobile || '';
    pageEndTempHolder.occupationEnd = startObject?.occupationOther || '';
    pageEndTempHolder.occupationOtherEnd = startObject?.occupationOther || '';
  }
  if (page === 'passcode') {
    pageEndTempHolder.passcodeEnd = startObject?.passcode || '';
  }
}
